import $ from 'jquery';

import carousel from './carousel';

const init = (): void => {
  carousel($);
};

export default { init };
